import { t } from '@lingui/core/macro';

import type { AccessoryCount } from '../../TanStackTable/CommandPalette/types';

export function formatAccessoryCount(count: AccessoryCount): string {
    const { affected, total } = count;
    if (affected === total) {
        return t`${affected} items`;
    }
    return t`${affected} of ${total} items`;
}

export function isMacPlatform(): boolean {
    if (typeof navigator === 'undefined') return false;

    // `userAgentData` (Chrome, Edge 90+) isn't in every TS lib, hence the assertion.
    const nav = navigator as Navigator & { userAgentData?: { platform?: string } };
    if (nav.userAgentData?.platform) {
        return nav.userAgentData.platform === 'macOS';
    }

    // Deprecated, but widely supported.
    return /Mac|iPod|iPhone|iPad/.test(navigator.platform);
}

/** `shortcut` is like ['⌘', 'D'] or ['Ctrl', 'Shift', 'E']. */
export function matchShortcut(
    shortcut: string[],
    event: { key: string; metaKey: boolean; ctrlKey: boolean; shiftKey: boolean },
    isMac: boolean,
): boolean {
    if (!shortcut || shortcut.length === 0) return false;

    const key = event.key.toUpperCase();
    const lastKey = shortcut[shortcut.length - 1].toUpperCase();

    if (key !== lastKey) return false;

    const needsCmd = shortcut.some((k) => k === '⌘' || k.toLowerCase() === 'cmd');
    const needsCtrl = shortcut.some((k) => k.toLowerCase() === 'ctrl');
    const needsShift = shortcut.some((k) => k.toLowerCase() === 'shift' || k === '⇧');

    // Cmd and Ctrl both mean the platform's modifier.
    const cmdOrCtrlMatch =
        needsCmd || needsCtrl ? (isMac ? event.metaKey : event.ctrlKey) : !event.metaKey && !event.ctrlKey;
    const shiftMatch = needsShift ? event.shiftKey : !event.shiftKey;

    return cmdOrCtrlMatch && shiftMatch;
}
